import { Outlet } from 'react-router-dom'
import { TopNavigation } from '../TopNavigation'
import { RAGNavigation } from './RAGNavigation'
import { TenantBadge } from './HUD/TenantBadge'

export function RagLayout() {

    return (
        <div className="flex flex-col h-screen bg-[#0A0A0A] text-white overflow-hidden font-sans">
            {/* BAND 0: Standard App Header */}
            <div className="h-12 border-b border-white/10 bg-[#0A0A0A] z-20 flex-shrink-0">
                <TopNavigation />
            </div>

            {/* BAND 1: Heads Up Display (Sub-header) */}
            <header className="flex-shrink-0 border-b border-white/10 bg-[#0F0F0F]/50 backdrop-blur-md z-10">
                {/* Title and HUD Row */}
                <div className="h-16 px-6 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center font-bold text-lg">
                            R
                        </div>
                        <span className="font-semibold text-lg tracking-tight text-white/90">RAG Cockpit</span>
                    </div>

                    {/* HUD Slot */}
                    <div className="flex items-center gap-4">
                        <TenantBadge />
                    </div>
                </div>

                {/* Navigation Row */}
                <RAGNavigation />
            </header>

            {/* Main Content Area */}
            <main className="flex-1 flex overflow-hidden">
                {/* BAND 2: The Workbench (Full Width) */}
                <div className="flex-1 flex flex-col min-w-0 bg-[#0A0A0A] overflow-y-auto">
                    <Outlet />
                </div>
            </main>
        </div>
    )
}
